import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import IconWarning from '@/shared/icons/NewDesign/IconWarning'
import type { StatusChipData } from '../useClientTabStatusChips'
import { NeutralRing, StatusChipButton } from '../styled-components'

type StatusChipProps = Omit<StatusChipData, 'key'>

const StatusChip = ({ text, tone, onClick }: StatusChipProps) => (
  <StatusChipButton type='button' $tone={tone} onClick={onClick}>
    {tone === 'ok' && <IconCheckCircle size={14} color='currentColor' />}
    {tone === 'warn' && <IconWarning size={14} color='currentColor' />}
    {tone === 'neutral' && <NeutralRing aria-hidden='true' />}
    {text}
  </StatusChipButton>
)

export default StatusChip
